import type { ChatMessage } from '@brighterly/lib-core-types/chat/interfaces'
import type { TutorContactChatMessage } from '@features/contact-tutor'

import { ChatMessageRole } from '@brighterly/lib-core-types/chat/enums'
import { TutorContactMessageRole } from '@brighterly/lib-core-types/tutor-contact/enums'

import { createChatMessage } from '@features/contact-tutor'

export type SubscriptionAssistantOption = 'change_plan' | 'pause' | 'question'

export interface SubscriptionAssistantOptionItem {
  code: SubscriptionAssistantOption
  title: string
}

export const SUBSCRIPTION_ASSISTANT_TITLE = 'Tutor’s assistant'
export const CUSTOMER_ASSISTANT_TITLE = 'Customer’s assistant'
export const SUBSCRIPTION_ASSISTANT_GREETING = 'Hey! 👋 I’m here to help with anything subscription-related — what can I do for you?'
export const SUBSCRIPTION_ASSISTANT_LISTENING = 'Sure, I’m listening! What’s on your mind about your subscription?'
export const SUBSCRIPTION_ASSISTANT_THANKS = 'Got it, thanks for sharing! I’ve passed this along to our team — sit tight, someone will reach out to you soon. 🙏'

export const SUBSCRIPTION_ASSISTANT_OPTIONS: SubscriptionAssistantOptionItem[] = [
  { code: 'change_plan', title: 'Change my plan' },
  { code: 'pause', title: 'Pause my subscription' },
  { code: 'question', title: 'Ask a question' },
]

const QUESTION_OPTION_TITLE = SUBSCRIPTION_ASSISTANT_OPTIONS.find(option => option.code === 'question')?.title ?? ''

const toTutorContactRole = (role: ChatMessageRole): TutorContactMessageRole => role === ChatMessageRole.User
  ? TutorContactMessageRole.User
  : TutorContactMessageRole.Assistant

export const buildAssistantGreeting = (): TutorContactChatMessage[] => [
  createChatMessage(TutorContactMessageRole.Assistant, SUBSCRIPTION_ASSISTANT_GREETING),
]

export const buildAssistantQuestionOpening = (): TutorContactChatMessage[] => [
  createChatMessage(TutorContactMessageRole.User, QUESTION_OPTION_TITLE),
  createChatMessage(TutorContactMessageRole.Assistant, SUBSCRIPTION_ASSISTANT_LISTENING),
]

export const restoreAssistantMessages = (messages: ChatMessage[]): TutorContactChatMessage[] => [
  ...buildAssistantGreeting(),
  ...buildAssistantQuestionOpening(),
  ...messages.map(({ role, content }) => createChatMessage(toTutorContactRole(role), content)),
]
